import { render } from "./WidgetBmbLinkverwaltung.vue?vue&type=template&id=6ade8cbe&scoped=true&ts=true"
import script from "./WidgetBmbLinkverwaltung.vue?vue&type=script&lang=ts"
export * from "./WidgetBmbLinkverwaltung.vue?vue&type=script&lang=ts"

import "./WidgetBmbLinkverwaltung.vue?vue&type=style&index=0&id=6ade8cbe&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ade8cbe"]])

export default __exports__